// Externe Bibliotheken
import React, { useEffect } from 'react';

// Interne Module
import * as storage from '@/_helper//storage';

// Komponenten
import Header from '@/comp/header/header';
import Footer from '@/comp/footer/Footer';

// Styles
import './revalidation.scss';

export const Revalidation = () => {
    useEffect(() => {
        document.title = '🕒 Ihre Buchungsdaten werden aktualisiert ' + window.$documentTitle;

        if (!storage.get('refreshData')) {
            window.location.href = '#/';
        }

        window.addEventListener('storage', () => {
            if (storage.get('newData') || !storage.get('refreshData')) {
                window.location.href = '#/';
            }
        });

        setInterval(() => {
            let elem = document.querySelector('.quotes .active');
            let prev = document.querySelector('.quotes .previous');
            if (prev !== null) {
                prev.classList.remove('previous');
            }
            if (elem !== null) {
                if (elem.nextSibling === null) {
                    elem.classList.add('previous');
                    elem.classList.remove('active');
                    document.querySelector('.quotes .slide').classList.add('active');
                } else {
                    let nextElem = elem.nextSibling;
                    elem.classList.remove('active');
                    elem.classList.add('previous');
                    nextElem.classList.add('active');
                }
            }
        }, 10000);
        return clearInterval;
    }, []);

    return (
        <div className="page-revalidation">
            <Header />
            <div className="content-wrapper">
                <div className="refreshData-wrapper">
                    <div className="inner">
                        <div className="logo"></div>
                        <div className="main">
                            <div className="cnt">
                                Ihre Buchungsdaten werden aktualisiert.
                                <br />
                                Bitte lassen Sie das Fenster geöffnet. Gleich geht es weiter.
                            </div>
                            <div className="loading-dots">
                                <span className="loading-ptr-1"></span>
                                <span className="loading-ptr-2"></span>
                                <span className="loading-ptr-3"></span>
                            </div>
                        </div>
                        <div className="quotes">
                            <div className="slide active">
                                Ihre Reise, Ihre Entscheidung – Im Kundenbereich gestalten Sie Ihr Urlaubserlebnis
                                individuell.
                            </div>
                            <div className="slide">
                                AurumTours bringt Sie an die schönsten Orte. Ihr nächstes Abenteuer wartet schon auf
                                Sie.
                            </div>
                            <div className="slide">
                                Egal ob Strandurlaub, Fernreise oder Städtetrip – AurumTours findet die besten Angebote.
                            </div>
                            <div className="slide">
                                Mit AurumTours erleben Sie Service und Qualität, auf die Sie sich verlassen können.
                            </div>
                            <div className="slide">
                                Ihre Reise, unser Versprechen – Unvergessliche Momente und erstklassiger Service, immer
                                inklusive.
                            </div>
                            <div className="slide">
                                AurumTours bietet Zusatzleistungen wie Rail&Fly sowie Transfer vom Flughafen zur
                                Unterkunft.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};
